import { NgModule, Component, OnInit, OnDestroy } from '@angular/core';
import { Field, FieldWrapper, FieldType } from 'ng-formly';
import { EntityfieldApi } from '../../sdk/services/custom';
import { Router, ActivatedRoute } from '@angular/router';
import { LoopBackFilter } from '../../sdk/models/';
import { EntityrecordApi } from '../../sdk/services/custom';
import * as _ from "lodash";
import { CacheService, CacheStoragesEnum } from 'ng2-cache/ng2-cache';
import { LoopBackAuth } from '../../sdk/services/core/auth.service';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { TypeaheadMatch } from 'ng2-bootstrap/typeahead';
import 'rxjs/add/operator/takeUntil';
import { Subject } from 'rxjs/Subject';

/*
This typeahead works only for navigation currently , it needs to be modified to be used in forms
*/

@Component({
    selector: 'typeahead',
    template: `
    <template #customItemTemplate let-model="item" let-index="index">
   <span class="dropdown-item">{{model?.data?.name}}</span>
</template>
   <input [(ngModel)]="asyncSelected"
         [typeahead]="dataSource"
         (typeaheadLoading)="changeTypeaheadLoading($event)"
         (typeaheadNoResults)="changeTypeaheadNoResults($event)"
         (typeaheadOnSelect)="typeaheadOnSelect($event)"
         [typeaheadItemTemplate]="customItemTemplate"
         typeaheadOptionsLimit="7"
         typeaheadOptionField="name"
         placeholder="Search"
         class="form-control">
  <div *ngIf="typeaheadLoading===true">
    <i class="glyphicon glyphicon-refresh ng-hide" style=""></i>
  </div>
  <div *ngIf="typeaheadNoResults===true" class="" style="">
    <i class="glyphicon glyphicon-remove"></i> No Results Found
  </div>
  `,
    providers: [EntityfieldApi],
    styleUrls: ['./typeahead.scss']


})
export class TypeaheadComponent extends FieldType implements OnInit, OnDestroy {
    private _loopbackfilter: LoopBackFilter = <LoopBackFilter>{};
    private items: any = [];
    private selectedvalues: any = [];
    private subscriptions: any = [];
    private currentuser;
    private appId;
    public asyncSelected: string;
    public typeaheadLoading: boolean;
    public typeaheadNoResults: boolean;
    public dataSource: Observable<any>;
    private ngUnsubscribe: Subject<void> = new Subject<void>();



    constructor(private _EntityrecordApi: EntityrecordApi, private _LoopBackAuth: LoopBackAuth, private router: Router) {
        super();

        this.dataSource = Observable.create((observer: any) => {
            this._loopbackfilter.where = {};
            this._loopbackfilter.where['appId'] = this.appId;
            this._loopbackfilter.where['entityId'] = this.field['lookupfield'];
            this._loopbackfilter.where['data.' + this.field['lookupfieldname']] = { "like": this.asyncSelected, "options": "i" };
            this._loopbackfilter.limit = 10;
            this._loopbackfilter.fields = ["id", "data"];

            //Get the fields for the App
            this.subscriptions.push(this._EntityrecordApi.find(this._loopbackfilter).subscribe((results) => {
                this.items = results;
                observer.next(results);
            }));
        });
    }

    ngOnInit() {
        this.currentuser = this._LoopBackAuth.getCurrentUserData();
        this.appId = this.currentuser.appId;
    }

    public changeTypeaheadLoading(e: boolean): void {
        this.typeaheadLoading = e;
    }

    public changeTypeaheadNoResults(e: boolean): void {
        this.typeaheadNoResults = e;
        this.items = [];
    }

    public typeaheadOnSelect(e: TypeaheadMatch): void {
        this.asyncSelected = e.item.data.name;
        /*
        Get the item from the list and use that to process the selected item
        */

        if (this.to.detailnavigation && e.item["id"]) {
            this.router.navigate(['/detailpage/' + e.item["id"]]);
            return;
        }
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
        for (var i = 0; i < this.subscriptions.length; i++) {
            this.subscriptions[i].unsubscribe();
        }
    }

}





// WEBPACK FOOTER //
// ./src/app/shared/components/fields/typeahead.ts